import script from "./QuestionAndAnswer.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionAndAnswer.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionAndAnswer.vue?vue&type=style&index=0&id=479e33c3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-479e33c3"]])

export default __exports__